<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <mat-card-title>
      <h2>Inventario de Insumos</h2>
    </mat-card-title>

    <div
      *ngIf="isLoading"
      class="d-flex flex-col flex-wrap align-items-center justify-content-center text-center"
      style="padding-bottom: 36px"
    >
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p class="m-t-16 f-w-600 mat-subtitle-1">
        Cargando Ingresos...
        <span
          *ngIf="loadedItemsCount > 0"
          class="d-block f-s-14 text-muted m-t-4"
        >
          ({{ loadedItemsCount }} registros cargados)
        </span>
      </p>
    </div>

    <div *ngIf="!isLoading" class="row justify-content-between">
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
            >Proveedor</mat-label
          >
          <mat-select
            [(value)]="selectProveedor"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="">Todos</mat-option>
            <mat-option
              *ngFor="let supplier of suppliersList"
              value="{{ supplier }}"
              >{{ supplier }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
            >Número de Factura</mat-label
          >
          <mat-select
            [(value)]="selectFactura"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let invoiceNumber of invoiceNumbers"
              value="{{ invoiceNumber }}"
              >{{ invoiceNumber }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
            >Ubicación</mat-label
          >
          <mat-select
            [(value)]="selectUbicacion"
            (selectionChange)="applyFilterSelect()"
          >
            <mat-option value="{{ null }}">No seleccionar</mat-option>
            <mat-option
              *ngFor="let ubicacion of arrayUbicaciones"
              value="{{ ubicacion }}"
              >{{ ubicacion }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-4 w-100">
        <mat-label class="mat-subtitle-2 f-w-600 d-block m-b-24"
          >Fecha Creación</mat-label
        >
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <mat-datepicker-toggle
            matSuffix
            [for]="rangePicker2"
          ></mat-datepicker-toggle>

          <mat-date-range-input [rangePicker]="rangePicker2">
            <input
              matStartDate
              placeholder="Inicio"
              [(ngModel)]="startDate"
              placeholder="Dia/Mes/Año"
            />
            <input
              matEndDate
              placeholder="Fin"
              [(ngModel)]="endDate"
              placeholder="Dia/Mes/Año"
            />
          </mat-date-range-input>

          <mat-date-range-picker #rangePicker2>
            <mat-date-range-picker-actions>
              <button mat-raised-button matDateRangePickerCancel>Cancel</button>
              <button
                mat-raised-button
                color="primary"
                (click)="applyFilterSelect()"
                matDateRangePickerApply
              >
                Filtrar
              </button>

              <button
                mat-raised-button
                color="warn"
                matDateRangePickerCancel
                (click)="cleanDateSelected()"
              >
                Limpiar
              </button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="!isLoading" class="row justify-content-between">
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input
            matInput
            placeholder="Buscar..."
            (keyup)="applyFilter($event)"
          />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="w-100 col-sm-4">
        <button
          mat-raised-button
          color="primary"
          (click)="navigateToAddIngreso()"
        >
          Agregar Ingreso
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-content
    [style.display]="
      !isLoading && dataSource.filteredData.length !== 0 ? 'block' : 'none'
    "
    style="padding: 36px"
  >
    <div *ngIf="!isLoading" class="table-responsive">
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="no-wrap m-t-0 v-middle w-100"
      >
        <ng-container matColumnDef="fileNumber">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por N° File"
            class="f-w-600 f-s-15 custom-column"
          >
            N° File
          </th>
          <td
            mat-cell
            *matCellDef="let inflow"
            class="f-s-14 custom-column short"
          >
            <ng-container *ngIf="!inflow?.fileNumber && inflow?.numFactura">
              <span class="bg-light-primar rounded f-w-600 p-6 p-y-4 f-s-12"
                >Con documentos contables</span
              >
            </ng-container>
            <ng-container *ngIf="!inflow?.fileNumber && !inflow?.numFactura">
              <span
                style="color: #757575"
                class="bg-light-primary rounded f-w-600 p-6 p-y-4 f-s-12"
                >Sin File</span
              >
            </ng-container>
            <ng-container *ngIf="inflow?.fileNumber && !inflow?.numFactura">
              <span
                class="bg-light-primary text-accent rounded f-w-600 p-6 p-y-4 f-s-12"
                >{{ inflow?.fileNumber || "-" }}</span
              >
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="detalleInsumos">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por Nombre de Insumo"
            class="f-w-600 f-s-15 custom-column"
          >
            Nombre Insumos
          </th>
          <td
            mat-cell
            *matCellDef="let foodInflow"
            class="f-s-14 custom-column"
          >
            <div *ngIf="foodInflow.detalleInsumos?.length">
              <p *ngFor="let foodItem of foodInflow.detalleInsumos">
                {{ foodItem?.nombreInsumo || "-" }}
              </p>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="cantidad">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por Cantidad de Insumos"
            class="f-w-600 f-s-15 custom-column"
          >
            Cantidad Insumos
          </th>
          <td
            mat-cell
            *matCellDef="let foodInflow"
            class="f-s-14 custom-column"
          >
            <div *ngIf="foodInflow.detalleInsumos?.length">
              <p *ngFor="let insumo of foodInflow.detalleInsumos">
                {{ (insumo?.cantidad | number: "1.2-2") || "-" }} -
                {{ insumo.unidadMedida }}
              </p>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="costo">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por Costo de Insumos"
            class="f-w-600 f-s-15 custom-column"
          >
            Costo Insumos
          </th>
          <td
            mat-cell
            *matCellDef="let foodInflow"
            class="f-s-14 custom-column"
          >
            <div *ngIf="foodInflow.detalleInsumos?.length">
              <p *ngFor="let insumo of foodInflow.detalleInsumos">
                {{ (insumo?.costo | number: "1.2-2") || "-" }}
              </p>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="costoTotal">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por Costo Total de Insumos"
            class="f-w-600 f-s-15 custom-column"
          >
            Costo Total Insumos
          </th>
          <td
            mat-cell
            *matCellDef="let foodInflow"
            class="f-s-14 custom-column"
          >
            {{ (foodInflow?.costoTotal | number: "1.2-2") || "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="observation">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por Observación"
            class="f-w-600 f-s-15 custom-column"
          >
            Observación
          </th>
          <td
            mat-cell
            *matCellDef="let foodInflow"
            class="f-s-14 custom-column"
          >
            {{ foodInflow?.observation || "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="editar">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-15 custom-column"
          >
            Editar
          </th>
          <td
            mat-cell
            *matCellDef="let foodInflow"
            class="f-s-14 custom-column"
          >
            <button
              mat-icon-button
              color="primary"
              (click)="navigateToEditIngreso(foodInflow)"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-15 custom-column"
          >
            Eliminar
          </th>
          <td
            mat-cell
            *matCellDef="let element; let i = index"
            class="f-s-14 custom-column"
          >
            <button mat-icon-button (click)="deleteIngreso(element, i)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="proveedor">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por Proveedor"
            class="f-w-600 f-s-15 custom-column"
          >
            Proveedor
          </th>
          <td mat-cell *matCellDef="let inflow" class="f-s-14 custom-column">
            {{ inflow.proveedor?.razonSocial || "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="factura">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por N° Factura / Recibo"
            class="f-w-600 f-s-15 custom-column"
          >
            N° Factura / Recibo
          </th>
          <td mat-cell *matCellDef="let inflow" class="f-s-14 custom-column">
            {{ inflow?.numFactura || (inflow?.numRecibo ?? "-") }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ubicacion">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por Ubicación"
            class="f-w-600 f-s-15 custom-column"
          >
            Ubicación
          </th>
          <td mat-cell *matCellDef="let inflow" class="f-s-14 custom-column">
            {{ inflow?.locacion || "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="efectiveDate">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header="efectiveDate"
            sortActionDescription="Ordenar por Fecha de Factura, Recibo, Adquisición o Creación"
          >
            Fecha de Factura/Adquisición
          </th>
          <td mat-cell *matCellDef="let inflow" class="f-s-14 custom-column">
            {{
              (inflow?.fechaFactura | date: "dd/MM/yyyy") ||
                (inflow?.fechaRecibo | date: "dd/MM/yyyy") ||
                (inflow?.acquisitionDate | date: "dd/MM/yyyy") ||
                (inflow?.createdAt | date: "dd/MM/yyyy")
            }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div [hidden]="isLoading" style="width: 100%">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>

  <div
    *ngIf="!isLoading && dataSource?.filteredData?.length === 0"
    class="d-flex justify-content-center align-items-center"
    style="width: 100%; height: 400px; text-align: center"
  >
    Lo sentimos. No tenemos datos para esta búsqueda.
    <br />Por favor, intenta con otro término.
  </div>
</mat-card>
